<p>default task-details works!</p>
